import { isEmpty } from 'lodash'
import { TPosAccount } from 'types/posAccounts'

export const filterPosAccountsByStatus = (status: string, allAccountsWithRole: TPosAccount[]) => {
  return isEmpty(status) || status === 'all'
    ? allAccountsWithRole
    : allAccountsWithRole?.filter(
        (account: TPosAccount) =>
          (status === 'active' && isEmpty(account?.deactivatedAt)) ||
          (status === 'inactive' && !isEmpty(account?.deactivatedAt))
      )
}
